import React from 'react';

import { Box } from 'app/shared/components/atoms';
import { useEventPageContext } from 'app/fan/context/EventPage';
import { ExpressCheckoutContextProvider } from 'app/fan/context/ExpressCheckout';
import { StripeElementsProvider } from 'app/fan/context/StripeElementsProvider';
import { EventPageTemplate } from 'app/fan/components/templates';
import {
  CheckoutWidget,
  EventCTAWidget,
} from 'app/fan/components/pages/Event/components';
import {
  useTicketsUnavailablePage,
  useTrackProductViewed,
} from 'app/fan/components/pages/Event/eventUtils';

export const BuyFlowTicketsUnavailableContainer = () => {
  const { event, eventAttendee } = useEventPageContext();
  const { isOutOfStock, ticketSaleStatus, pageQaid } =
    useTicketsUnavailablePage(event);

  useTrackProductViewed();

  // We will never run into this scenario, but include this code so that
  // Typescript knows to expect this to be present
  if (!event) {
    return null;
  }

  return (
    <EventPageTemplate
      data-qaid={pageQaid}
      event={event}
      isOutOfStock={isOutOfStock}
      ticketSaleStatus={ticketSaleStatus}
      attendeeState={eventAttendee?.currentState}
      secondColumn={
        <StripeElementsProvider eventId={event.id}>
          <ExpressCheckoutContextProvider
            event={event}
            eventAttendee={eventAttendee}
          >
            <CheckoutWidget disabled={true} />
          </ExpressCheckoutContextProvider>
        </StripeElementsProvider>
      }
    >
      <Box data-qaid="event-page-first-column-children">
        {!event.isSoldOut && !event.cancelled && (
          <EventCTAWidget
            event={event}
            eventAttendeeExists={!!eventAttendee}
            isBuyTicketsCTAEnabled={false}
            maxTicketsBought={false}
          />
        )}
      </Box>
    </EventPageTemplate>
  );
};
